import { Component, inject } from '@angular/core';
import { UiService } from '@services/ui.service';
import { RouterOutlet } from '@angular/router';
import { DashboardTopbarComponent } from '@modules/dashboard/layout/dashboard-topbar/dashboard-topbar.component';
import { MainMenuComponent } from '@modules/dashboard/layout/main-menu/main-menu.component';

@Component({
    selector: 'app-dashboard-layout',
    templateUrl: './dashboard-layout.component.html',
    imports: [RouterOutlet, DashboardTopbarComponent, MainMenuComponent],
    styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent {
    uiService = inject(UiService);
    sidebarOpen = this.uiService.sidebarOpen;

    toggleSidebar() {
        this.uiService.updateSidebarState();
    }
}
